/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import { isPrimitive as isNumber } from '@stdlib/assert-is-number';
import format from '@stdlib/error-tools-fmtprodmsg';
import isnan from '@stdlib/assert-is-nan';


// MAIN //

/**
* Validates values provided for minimum and maximum support.
*
* @private
* @param {number} a - minimum support
* @param {number} b - maximum support
* @returns {(Error|null)} error or null
*
* @example
* var err = validate( 1.0, 2.0 );
* if ( err ) {
*     throw err;
* }
*/
function validate( a, b ) {
	if ( !isNumber( a ) || isnan( a ) ) {
		return new TypeError( format( '0pB6v', a ) );
	}
	if ( !isNumber( b ) || isnan( b ) ) {
		return new TypeError( format( '0pB6w', b ) );
	}
	if ( a >= b ) {
		return new RangeError( format( '0pBEJ', a, b ) );
	}
	return null;
}


// EXPORTS //

export default validate;
